import { Component, inject, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import {
  NgbActiveModal,
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslocoDirective } from '@jsverse/transloco';
import { LanguageRepo } from '../../languages/language.repo';
import { ThemeService } from '@shared/services/themeService/theme.service';
import { AuthStoreService } from '@features/auth/infrastructure/services/auth-store/auth-store.service';
import { AuthApiService } from '@features/auth/infrastructure/services/auth-api/auth-api.service';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { UnsubscribeService } from '@shared/services/unsubscribe.service';
import { RolePermissionService } from '@shared/services/role-permission.service';

@Component({
  selector: 'app-user-modal',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    TranslocoDirective,
    NgClass
],
  providers: [
    UnsubscribeService,
  ],
  templateUrl: './user-modal.component.html',
  styleUrl: './user-modal.component.scss',
})
export class UserModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  private unsub = inject(UnsubscribeService);
  user = this.authStoreService.user();
  #rolePermissionService = inject(RolePermissionService);

  constructor(protected langRepo: LanguageRepo,
              protected themeService: ThemeService,
              private authStoreService: AuthStoreService,
              private authApiService: AuthApiService,
              private router: Router,
  ) {
  }

  ngOnInit(): void {
  }

  logout() {
    this.authApiService.logout(this.authStoreService.refreshToken()!).pipe(takeUntil(this.unsub.$unsub)).subscribe(() => {
      this.authStoreService.logout();
      this.router.navigate(['/auth']);
      this.activeModal.dismiss();
    });
  }

  getUserName() {
    return this.user?.firstname || this.user?.username || '';
  }

  isRoutePermitted(route: string) {
    return this.#rolePermissionService.isRoutePermitted(route);
  }

  goToSettings() {
    this.router.navigate(['/config']);
    this.activeModal.close();
  }
}
